module.exports = __webpack_public_path__ + "img/Zaentz.5b121cf9.png";